import React from 'react'
import { Switch, Route, useHistory } from "react-router-dom";
import star from './QuestionStep/assets/star.png'
import cloud1 from './QuestionStep/assets/calculator.png'
import cloud2 from './QuestionStep/assets/cloud3.png'
import middleGif from './QuestionStep/assets/17_calculator 2.gif'
import {  calculateResult  } from '../Store'
import CountUp from 'react-countup';
import './Home.css'


function Middle() {
    const history = useHistory();
    console.log("calculateResult 3");
    let theNumber = calculateResult();
    let yearsNumber = theNumber * 12;
    return (

        <div className="middle">
            <div className="up-middle">
                <img id="cloud1" className="cloud" src={cloud1} alt="" />
                <img id="cloud2" className="cloud3" src={cloud2} alt="" />
                <img className="star rotate" src={star} alt="" />
                <img className="star2 rotate2" src={star} alt="" />
                <img className="star3 rotate3" src={star} alt="" />
                <img className="middleGif" src={middleGif} alt="" />
            </div>
            <div className="reHeaderQ9">
                עד עכשיו הבנק
                <br/>
                כנראה עולה לכם כ-

            </div>
            <div className="numAndMonthQ9">
                <span className="number">
                    <span className="shahQ9">₪</span>
                    <CountUp separator="," start={0} end={theNumber} delay={0} duration={2.75}>
                        {({ countUpRef }) => (
                            <span className="middleNumberQ9">
                                <span  ref={countUpRef} />
                            </span>
                        )}
                    </CountUp>
                </span>
                <span className="monthQ9"> בחודש </span>
                <div className="yearAndNumberQ9">
                    <span className="ke">כ-</span>
                    <span className="bigNumberQ9">
                        <span>₪</span>
                        <CountUp separator="," start={0} end={yearsNumber} delay={0} duration={2.75}>
                            {({ countUpRef }) => (
                                <span>
                                    <span ref={countUpRef} />
                                </span>
                            )}
                        </CountUp>    
                    </span>
                    <span className="year"> בשנה </span>
                </div>
            </div>
            <div onClick={() => { history.push(`/Q/9`) }} className="takeToQ9">
                שנמשיך?
            </div>
        </div>


    )
}

export default Middle
